import React from "react";
import { IconButton, MenuItem, MenuItemProps } from "@mui/material";
import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons";

import { FontAwesomeSvgIcon } from "./FontAwesomeSvgIcon";

export type ConfirmInlineProps = {
  /** Triggered when user confirms the action */
  onConfirm: () => void;
  /** Triggered when user cancels the action */
  onCancel: () => void;
  /** When true, the component is disabled showing busy state */
  isBusy?: boolean;
  /** Optional label displayed before the buttons */
  label?: React.ReactNode;
} & Omit<MenuItemProps, "onConfirm" | "onCancel">;

/**
 * Light-weight inline confirmation menu item, useful inside dropdowns and lists.
 */
const ConfirmInline: React.FC<ConfirmInlineProps> = ({
  onConfirm,
  onCancel,
  isBusy = false,
  label = "Confirm?",
  ...menuItemProps
}) => {
  return (
    <MenuItem disabled={isBusy} sx={{ display: "flex", gap: 1 }} {...menuItemProps}>
      {label}
      <IconButton color="error" size="small" onClick={onConfirm} disabled={isBusy}>
        <FontAwesomeSvgIcon icon={faCheck} />
      </IconButton>
      <IconButton size="small" onClick={onCancel} disabled={isBusy}>
        <FontAwesomeSvgIcon icon={faTimes} />
      </IconButton>
    </MenuItem>
  );
};

export default React.memo(ConfirmInline);
